import type { AppointmentDetailFragment } from "@/gql/graphql";
import { timezoneUtils } from "@/lib/timezone";

export const formatTime = (date: string) => {
  const dateTime = timezoneUtils.fromISO(date);
  return `${dateTime.toFormat("dd.MM.yyyy")} at ${dateTime.toFormat("HH:mm")}`;
};

export const getCustomerName = (appointment: AppointmentDetailFragment | null) => {
  if (!appointment?.customer) return "Unknown Customer";
  return `${appointment.customer.firstName} ${appointment.customer.lastName}`.trim();
};

export const getDuration = (appointment: AppointmentDetailFragment | null) => {
  if (!appointment) return 0;
  const startTime = timezoneUtils.fromISO(appointment.startTime);
  const endTime = timezoneUtils.fromISO(appointment.endTime);
  return Math.round(endTime.diff(startTime, "minutes").minutes);
};
